export { default } from './Allergies';
